import { UserRights } from '@work4all/models/lib/additionalEnums/UserRights';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { PermissionsRequiredRightsByEntity } from '../types';

// ==========================================
// DMS Permission Configurations
// ==========================================

export const DMS_PERMISSIONS_REQUIRED_RIGHTS: PermissionsRequiredRightsByEntity =
  {
    // Visitation Reports
    [Entities.visitationReport]: {
      canAdd: [
        [
          {
            type: 'UserRight',
            value: UserRights.BesuchsberichteAnlegenAendern,
          },
          {
            type: 'UserRight',
            value: UserRights.BesuchsberichteAendernLoeschenEigene,
          },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.BesuchsberichteAnlegenAendern,
          ownlyOwnPermissionCode:
            UserRights.BesuchsberichteAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.BesuchsberichteLoeschen,
          ownlyOwnPermissionCode:
            UserRights.BesuchsberichteAendernLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },

    // Letters
    [Entities.letter]: {
      canAdd: [
        { type: 'UserRight', value: UserRights.KorrespondenzAnlegenAendern },
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.KorrespondenzAnlegenAendern,
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.KorrespondenzLoeschen,
          ownlyOwnPermissionCode: UserRights.KorrespondenzLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },

    // Emails
    [Entities.eMail]: {
      canAdd: [
        [
          { type: 'UserRight', value: UserRights.KorrespondenzAnlegenAendern },
          { type: 'UserRight', value: UserRights.KorrespondenzLoeschenEigene },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.KorrespondenzAnlegenAendern,
          ownlyOwnPermissionCode: UserRights.KorrespondenzLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.KorrespondenzLoeschen,
          ownlyOwnPermissionCode: UserRights.KorrespondenzLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },

    // Documents
    [Entities.document]: {
      canAdd: [
        [
          { type: 'UserRight', value: UserRights.KorrespondenzAnlegenAendern },
          { type: 'UserRight', value: UserRights.KorrespondenzLoeschenEigene },
        ],
      ],
      canEdit: [
        {
          type: 'UserRightOperation',
          value: UserRights.KorrespondenzAnlegenAendern,
          ownlyOwnPermissionCode: UserRights.KorrespondenzLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
      canDelete: [
        {
          type: 'UserRightOperation',
          value: UserRights.KorrespondenzLoeschen,
          ownlyOwnPermissionCode: UserRights.KorrespondenzLoeschenEigene,
          ownageProperty: ['userId', 'user.id'],
        },
      ],
    },
  };
